import cx from 'clsx';

// components
import { iconBtnType, IconButton } from '../../../molecules/icon-button';
import { Tooltip } from '../../../atoms/tooltip';
import { Icons } from '../../../../icons';

// styles
import { useStyles } from './TableExport.styles';

const TableExport = ({
  className = '',
  isLoadingExport = false,
  btnTitle = 'Export',
  onClick,
  exportDisabled,
  ...rest
}) => {
  const classes = useStyles();

  const isDisabled = isLoadingExport || exportDisabled;
  const renderFilterText = () => (isLoadingExport ? 'Loading' : btnTitle);

  const button = (
    <IconButton
      variant={iconBtnType.SECONDARY}
      onClick={onClick}
      disabled={isDisabled}
      className={cx(classes.filterBtn, {
        [classes.filterBtnDisabled]: isLoadingExport,
      })}
      {...rest}
    >
      <Icons glyph="export" color="currentColor" />
      {renderFilterText()}
    </IconButton>
  );

  return isDisabled ? (
    <Tooltip title="Export is disabled due to too many records" placement="top">
      <span>{button}</span>
    </Tooltip>
  ) : (
    button
  );
};

export { TableExport };
